import React, { useState } from "react";
import {Banner} from "../components/CreduMoney/Banner";
import { Link } from "react-router-dom";
import { GiPayMoney, GiTakeMyMoney } from "react-icons/gi";
import { VscCombine } from "react-icons/vsc";
import ChatButton from "../components/ChatButton";
import { FaApple } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";

import {
  MdOutlineFileDownload,
  MdOutlineFileUpload,
  MdOutlineDone,
} from "react-icons/md";
import step_2_img from "../images/step_2.png";
import step_3_img from "../images/step_3.png";
import { About } from "../components/CreduMoney/About";
import { Card } from "../components/CreduMoney/Card";
import { Feature } from "../components/CreduMoney/Feature";
import { FAQHome } from "../components/CreduMoney/FAQHome";

import img1 from "../images/mdi_bike-fast_sl.png"
import img2 from '../images/ph_less-than-or-equal-bold.png'
import img3 from "../images/fluent_money-16-filled.png"
import mobilesl from "../images/mobilesl.png"
import mobiles2 from "../images/mobiles2.JPG"
import { advantages, debtConsolidation, instantloan, secureFuture, shortloan, weWork } from "../components/content/text";
import { Helmet } from "react-helmet";

const Home = () => {
  const [step, setStep] = useState(1);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  
  return (
    <>
    <Helmet>
      <title>Apply for instant personal loan | CreduMoney</title>
      <meta name="title" content="Apply for instant personal loan | CreduMoney"/>
      <meta name="description" content="CreduMoney provides easy personal loan without any collateral and hidden charges with instant credit in your account. Apply now for personal loan and get quick funds."/>
    </Helmet>
      <div className="page_wrapper">
        <div className="container">
        <Banner />
        </div>
        <About/>

        <div className="services_section">
        <div className='services_card_sl_title my-center'>
            {/* <div className='services_card_sl_title-1'>What we do</div> */}
            <div className='services_card_sl_title-2'>Types of loans we offer:</div>
            <div className='services_card_sl_title-2 title-theme-color'>Loan Services</div>
        </div>         
          <div className="services_card_container">
              <Card title={"Salary Advance Loan"} icon={<GiPayMoney className="service_icon" />} img={img1} des={instantloan}/>
              <Card title={"First-Time Borrower Loan"} icon={<GiTakeMyMoney className="service_icon" />} img={img2} des={shortloan}/>
              <Card title={"Instant/Emergency Loan"} icon={<VscCombine className="service_icon" />} img={img3} des={debtConsolidation}/>
          </div>
        </div>

        {/*  */}
        <Feature/>
        <div className="features_section">
          <div className="advantages_wrapper">
            <div className="title_section">
              <h2 className="mt20 full-width text-center">
                Top Reasons to Trust CreduMoney for Instant Personal Loans
              </h2>
              <p className="mt5 text-center">
                Here's how we make your financial journey smooth
              </p>
            </div>
            <div className="advantages_section">
              <div className="container">
                <div className="advantages_section_row text-center">
                  {advantages?.map((item, index)=>{
                    return (
                      <div data-aos="zoom-in-down" className="advantage_section_card" key={index}>
                    <div className="advantage_section_icon_container mx-auto">
                      {item?.icon}
                    </div>
                    <div>
                      <h3>{item?.title}</h3>
                      <p>
                        {item?.description}
                      </p>
                    </div>
                  </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in-down" className="get_started_section">
          <div className="title_section ">
            <h2 className="mt20 full-width text-center">
              Get Started <span>Instantly</span>
            </h2>
            <p className="full-width text-center mt5">
              Download the CreduMoney app and get moving
            </p>
          </div>
          <div className="get_started_row">
            {step === 1 ? (
              <>
                <div className="image_section">
                  <img src={mobilesl} alt="" className="underlay_img" />
                  {/* <img src={overlay_img} className="overlay_img" /> */}
                </div>
              </>
            ) : step === 2 ? (
              <>
                <div className="image_section">
                  <img src={mobiles2} alt="" />
                </div>
              </>
            ) : step === 3 ? (
              <>
                <div className="image_section">
                  <img src={step_3_img} alt="" />
                </div>
              </>
            ) : (
              ""
            )}
            <div className="steps_section">
              <h3 className="mb50">How does this App Work ?</h3>
              <div
                className={
                  step === 1 ? "step_item flex step_active" : "step_item flex"
                }
              >
                <div
                  className={
                    step === 1
                      ? "step_icon_container icon_active"
                      : "step_icon_container"
                  }
                  onClick={(e) => setStep(1)}
                >
                  <MdOutlineFileDownload className="step_icon" />
                </div>
                <div className="step_content">
                  <h4 className="content_title">Download the App and Apply</h4>
                  <p>
                    Head over to apply for loan section and fill your basic
                    details to get started
                  </p>
                </div>
              </div>
              <div
                className={
                  step === 2 ? "step_item flex step_active" : "step_item flex"
                }
              >
                <div
                  className={
                    step === 2
                      ? "step_icon_container icon_active"
                      : "step_icon_container"
                  }
                  onClick={(e) => setStep(2)}
                >
                  <MdOutlineFileUpload className="step_icon" />
                </div>
                <div className="step_content">
                  <h4 className="content_title">Upload Documents</h4>
                  <p>
                    Upload KYC Documents (PAN and Aadhar Card) income proof &
                    wait for verification
                  </p>
                </div>
              </div>
              <div
                className={
                  step === 3
                    ? "step_item flex step_active last_item"
                    : "step_item flex last_item"
                }
              >
                <div
                  className={
                    step === 3
                      ? "step_icon_container icon_active"
                      : "step_icon_container"
                  }
                  onClick={(e) => setStep(3)}
                >
                  <MdOutlineDone className="step_icon" />
                </div>
                <div className="step_content">
                  <h4 className="content_title">Get Approved Instantly</h4>
                  <p>
                    Post verification the disbursal process is Initiated
                    instantly
                  </p>
                </div>
              </div>
              <div className="app_download_button_container ml70">
                <p className="mb10">Download the app now</p>
                <div className="flex flex-center button_wrapper">
                  <Link to="">
                    <FaApple className="app_download_icon" />
                  </Link>
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.credumoney.credumoney&pcampaignid=web_share"
                    target="_blank"
                  >
                    <DiAndroid className="app_download_icon" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
       <FAQHome/>
      </div>
      <ChatButton />
    </>
  );
};

export default Home;
